import { BUCKETS } from "@/constants";
import { getUserId } from "@/services/supabase/auth/actions/getUserId";
import { supabase } from "@/services/supabase/createClient";
import { duplicateFolderInStorage } from "@/services/supabase/storage/actions/dupplicateFolderInStorage";

export const createPromptbookFromTemplate = async (
  templateId: string,
  name: string,
  workspaceId: string,
  teamId?: string,
) => {
  const userId = teamId || (await getUserId());
  const { data: newPromptbookId, error } = await supabase.rpc("create_promptbook_from_template", {
    p_template_id: templateId,
    p_name: name,
    p_workspace_id: workspaceId,
    p_owner_id: userId,
  });

  if (newPromptbookId) {
    await duplicateFolderInStorage(
      BUCKETS["promptbook-templates"],
      `${templateId}/files`,
      BUCKETS.promptbooks,
      `${newPromptbookId}/files`,
    );
  }

  return { newPromptbookId, error };
};
